import { ChangeEvent, useCallback, useState } from 'react';
import { normalizeDecimal } from 'shared/lib/serializers';

import { validateOnlyNumbers } from './useValidateInputField.helpers';
import { InputProps, ValidationTypes } from './useValidateInputField.types';

export const useValidateInputField = (
  options: InputProps,
): [
  string,
  (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => string | boolean,
  (value: string) => void,
] => {
  const { type, decimals, maxValue, initialState = '' } = options ?? {};
  const [inputValue, setInputValue] = useState(initialState);

  const handleChangeValue = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const { value } = event.target;

    if (value === '' || type === ValidationTypes.string) {
      setInputValue(value);
      return value;
    }

    if (type === ValidationTypes.number) {
      const isNumber = validateOnlyNumbers({ value, decimals: decimals || 18 });

      if (!isNumber) {
        return false;
      }

      const normalized = normalizeDecimal(value);
      const maxNumberValue = maxValue ? Number(maxValue) : Infinity;
      if (Number(normalized) <= maxNumberValue) {
        setInputValue(normalized);
      }

      return normalized;
    }

    if (type === ValidationTypes.int) {
      const isInteger = validateOnlyNumbers({ value, isInteger: true, decimals: decimals || 18 });

      if (!isInteger) return false;

      setInputValue(value);
      return value;
    }

    return value;
  };

  const handleSetOriginValue = useCallback((value: string) => {
    setInputValue(value);
  }, []);

  return [inputValue, handleChangeValue, handleSetOriginValue];
};
